import React from 'react';
import PropTypes from 'prop-types';
import SlateTextInput from '../../Shared/SlateTextInput';
import './EmailsInput.css';

var EmailsInput = (function () {
  function EmailsInput(props) {
    React.Component.call(this, props);
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
  }

  EmailsInput.prototype = Object.create(React.Component.prototype);
  EmailsInput.prototype.constructor = EmailsInput;

  EmailsInput.prototype.handleChangeEmail = function (index, e) {
    var emails = this.props.emails.slice();
    emails[index] = e.currentTarget.value;
    this.props.onChange(emails);
  };

  EmailsInput.prototype.handleDelete = function (e, index) {
    e.stopPropagation();
    var emails = this.props.emails.filter(function (email, i) {
      return i !== index;
    });
    this.props.onChange(emails);
  };

  EmailsInput.prototype.handleAdd = function () {
    var emails = this.props.emails.concat(['']);
    this.props.onChange(emails);
  };

  EmailsInput.prototype.render = function () {
    var self = this;
    var emails = this.props.emails;
    var errors = this.props.errors || {};
    var addLabel = this.props.addLabel;
    var placeholder = this.props.placeholder;
    var t = this.props.t;

    return (
      <div style={{display: 'flex', flexDirection: 'column'}}>
        <button type="button" className="settings-add-btn" onClick={self.handleAdd}>
          <span className="material-symbols-outlined">add</span>
          {addLabel}
        </button>
        {!!emails.length &&
          <div className="emails-list">
            {emails.map(function (email, index) {
              return (
                <div className="settings-rule" key={index} data-index={index}>
                  <div className="settings-rule-items-container">
                    <div style={{width: 400}}>
                      <SlateTextInput
                        name={'email-' + index}
                        value={email}
                        type="email"
                        fullWidth
                        onChange={function (e) { self.handleChangeEmail(index, e); }}
                        error={errors[index] || ''}
                        placeholder={placeholder}
                      />
                    </div>
                  </div>
                  <div className="settings-rule-btn-remove">
                    <button
                      type="button"
                      className="settings-rule-remove-btn"
                      onClick={function (e) { self.handleDelete(e, index); }}
                      aria-label={t && t('btn:remove')}
                    >
                      <i className="material-icons">close</i>
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        }
      </div>
    );
  };

  return EmailsInput;
}());

EmailsInput.propTypes = {
  emails: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  addLabel: PropTypes.string,
  placeholder: PropTypes.string,
  t: PropTypes.func,
};

export default EmailsInput;
